"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadFile = exports.getFileExtensionFromBlob = exports.DOC_API_URL = exports.styles = void 0;
const react_1 = __importDefault(require("react"));
const ImageWithHeaders_1 = require("./ImageWithHeaders");
const hooks_1 = require("../../hooks");
const TGPageLabelWrapper_1 = __importDefault(require("./TGPageLabelWrapper"));
exports.styles = {
    photoContainer: {
        height: 80,
        width: 80,
        display: 'inline-flex',
        flexShrink: 0,
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 5,
        cursor: 'pointer',
    },
};
exports.DOC_API_URL = process.env.NODE_ENV === 'production'
    ? '/media/v1/'
    : `${process.env.REACT_APP_SERVER_URL || 'http://localhost:5000'}/media/v1/`;
const getFileExtensionFromBlob = async (blob) => {
    const stream = await blob.arrayBuffer();
    const arr = new Uint8Array(stream).subarray(0, 4);
    let header = '';
    for (let i = 0; i < arr.length; i++) {
        header += arr[i].toString(16);
    }
    let type = '';
    switch (header) {
        case '89504e47':
            type = 'png';
            break;
        case '47494638':
            type = 'gif';
            break;
        case 'ffd8ffe0':
        case 'ffd8ffe1':
        case 'ffd8ffe2':
        case 'ffd8ffe3':
        case 'ffd8ffe8':
            type = 'jpeg';
            break;
        case '504b34': //Spot checking, this looks like the only header for excel files - all files I have tested have had this.
            type = 'xlsx';
            break;
        default:
            type = '';
            break;
    }
    return type;
};
exports.getFileExtensionFromBlob = getFileExtensionFromBlob;
const downloadFile = async (fileUrl, fileName, isReview, fileExtension) => {
    const token = await hooks_1.AuthConnector.getToken();
    const response = await fetch(fileUrl, {
        method: 'GET',
        headers: new Headers({
            Authorization: 'Bearer ' + token,
        }),
    });
    const blob = await response.blob();
    fileExtension = fileExtension || (await (0, exports.getFileExtensionFromBlob)(blob));
    if (!fileExtension) {
        if (isReview) {
            fileExtension = 'xlsx';
        }
        else {
            fileExtension = 'csv';
        }
    }
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileExtension ? `${fileName}.${fileExtension}` : fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
};
exports.downloadFile = downloadFile;
const TGPageMediaField = props => {
    const { value, type, width, height, translateFunction = text => text } = props;
    const photoViewer = (0, hooks_1.usePhotoViewer)();
    const handlePhotoClick = (selectedPhoto) => {
        photoViewer === null || photoViewer === void 0 ? void 0 : photoViewer.open({
            images: value,
            selectedPhoto,
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TGPageLabelWrapper_1.default, { required: props.required, readOnly: true, label: props.label, info: props.info, oneLine: false, translateFunction: translateFunction }),
        type === 'image' &&
            Array.isArray(value) &&
            value.map((item, index) => (react_1.default.createElement("div", { key: 'photo' + index, style: Object.assign(Object.assign(Object.assign({}, exports.styles.photoContainer), (width && { width })), (height && { height })), onClick: () => handlePhotoClick(item) },
                react_1.default.createElement(ImageWithHeaders_1.ImageWithHeaders, { url: exports.DOC_API_URL + item })))),
        type === 'file' &&
            Array.isArray(value) &&
            value.map((item, index) => (react_1.default.createElement("div", { onClick: () => (0, exports.downloadFile)(exports.DOC_API_URL + item.id, item.name.substring(0, item.name.lastIndexOf('.')), undefined, item.name.substring(item.name.lastIndexOf('.') + 1)), style: {
                    cursor: 'pointer',
                    color: '#56CCF2',
                } }, item.name)))));
};
exports.default = TGPageMediaField;
//# sourceMappingURL=TGPageMediaField.js.map